import primaryButtonHover from '../../../../../common/algorithms/primary-button-hover';

const primary = (params) => primaryButtonHover(params, true);

export default primary;
